import moment from 'moment'

export const ganttChartView = {
    id: '',
    module: '',
    customerComplaintId: '',
    complaintNo: '',
    ncrId: '',
    ncrNo: '',
    recallId: '',
    recallNo: '',
}

export const ganttChartData = {
    name: '',
    start: moment().format('YYYY-MM-DD'),
    end : moment().format('YYYY-MM-DD'),
}